import React, { useState } from "react";
import moment from "moment-timezone";
import { ButtonBase, IconButton, makeStyles } from "@material-ui/core";
import { CheckContactCommunication, CreateActivity } from "../../Services";
import { Spinner } from "../SpinnerComponent/Spinner";
import CanCommunicateAlertDialog from "./components/CanCommunicateAlertDialog";
import BrightCallAppAlertDialog from "./components/BrightCallAppAlertDialog";
import { showError } from "../../Helper";
import { useSelector } from "react-redux";
import { useLayoutDetection } from "../../Hooks";
import { PhoneIcon } from "../../assets/icons";

const styles = makeStyles({
  socialLinkIcon: {
    boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
    padding: "4px",
    borderRadius: "24px",
    background: "#EAECF0",
    border: `1px solid #EAECF0`,
    "&:hover": {
      background: '#d0d5dd',
      boxShadow: "none",
      border: `1px solid #d0d5dd`,
    },
    "&:focus": {
      boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px rgba(152, 162, 179, 0.14)',
    },
    "&:disabled": {
      "& svg, & svg path": {
        fill: "#98A2B3",
      },
      border: `1px solid #EAECF0`,
    },
  },
});

const BrightCallButton = ({ leadId, contactId, phoneNumber, disabled }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const { loginResponse } = useSelector((state) => state.login);
  const [brightCallAppAlertOpen, setBrightCallAppAlertOpen] = useState(false);
  const [canCommunicate, setCanCommunicate] = useState(true);
  const { isNewLayout: isReskinningLayout, hasNewLayout } =
    useLayoutDetection();
  const isNewLayout = hasNewLayout && isReskinningLayout;
  const classes = styles();
  async function openBrightcallApp(e) {
    if (e) {
      e.stopPropagation();
    }
    await CreateActivity({
      assignAgentId: loginResponse.userId,
      activityDate: moment()
        .tz("Asia/Dubai")
        .format("YYYY-MM-DDTHH:mm:ss.SSSSSSZZ"),
      relatedLeadNumberId: leadId,
      relatedUnitNumberId: null,
      relatedPortfolioId: null,
      relatedWorkOrderId: null,
      relatedMaintenanceContractId: null,
      activityTypeId: 555,
      subject: null,
      comments: null,
      isOpen: true,
      fileId: null,
      fileName: null,
      relatedActivityToId: null,
      activityReminders: [],
    });
    const protocolUrl = `brightcall://start-call?number=${phoneNumber}&lead_id=${leadId}`;

    const timeout = setTimeout(() => {
      setIsLoading(false);
      setBrightCallAppAlertOpen(true);
    }, 5000);

    window.location.href = protocolUrl;
    window.onblur = () => {
      setIsLoading(false);
      clearTimeout(timeout);
      setAlertOpen(false);
    };
  }
  const onCallClick = async (e) => {
    e.stopPropagation();
    setIsLoading(true);
    const res = await CheckContactCommunication({ leadId, contactId });
    setIsLoading(false);
    if ("canCommunicate" in res) {
      setCanCommunicate(!!res.canCommunicate);
      if (!res.canCommunicate) {
        setAlertOpen(true);
        return;
      } else {
        openBrightcallApp();
        return;
      }
    }
    showError("An error occurred while checking communication status.");
    setIsLoading(false);
  };

  if (isNewLayout) {
    return (
      <>
        <IconButton disabled={disabled} className={classes.socialLinkIcon} disableRipple variant="contained" onClick={onCallClick}>
          <PhoneIcon width={20} height={20} fill={"#344054"} />
        </IconButton>
        <CanCommunicateAlertDialog
          open={alertOpen}
          onClose={() => setAlertOpen(false)}
          onConfirm={openBrightcallApp}
          canCommunicate={canCommunicate}
        />
        <BrightCallAppAlertDialog
          open={brightCallAppAlertOpen}
          onClose={() => setBrightCallAppAlertOpen(false)}
        />
      </>
    );
  }

  return (
    <div>
      {<Spinner isActive={isLoading} isAbsolute />}
      <ButtonBase className="btns-icon theme-solid" onClick={onCallClick}>
        <span className="mdi mdi-phone" />
      </ButtonBase>
      <CanCommunicateAlertDialog
        open={alertOpen}
        onClose={() => setAlertOpen(false)}
        onConfirm={openBrightcallApp}
        canCommunicate={canCommunicate}
      />
      <BrightCallAppAlertDialog
        open={brightCallAppAlertOpen}
        onClose={() => setBrightCallAppAlertOpen(false)}
      />
    </div>
  );
};
export default BrightCallButton;
